interface IBlockStorageItem {
  recordId: string;
  viewId: string;
}

interface IBlockStorageInput extends IBlockStorageItem {
  blockId: string;
}

export const buildStorageKey = (blockId: string) => {
  return `block-${blockId}`;
};

export const setIdsToLocalStorage = ({ blockId, recordId, viewId }: IBlockStorageInput) => {
  const storageString = JSON.stringify({ recordId, viewId });
  window.localStorage.setItem(buildStorageKey(blockId), storageString);
};

export const getIdsFromLocalStorage = (blockId: string): IBlockStorageItem | null => {
  const storageString = window.localStorage.getItem(buildStorageKey(blockId));
  if (storageString === null) return null;

  try {
    return JSON.parse(storageString);
  } catch (err) {
    console.warn('Failed to parse local storage value', err);
    return null;
  }
};
